import React from "react";
import { arrayOf, shape, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { QuickLinksSupport } from "./QuickLInksSupport";

const QuickLinksSupportConnector = ({ data }) => (
	<QuickLinksSupport title={data.title} links={data.links} moreInfoLink={data.moreInfoLink} />
);

QuickLinksSupportConnector.propTypes = {
	data: shape({
		title: string.isRequired,
		links: arrayOf(
			shape({
				id: string,
				url: string,
				target: string,
				linkText: string,
			})
		),
		moreInfoLink: shape({
			id: string,
			url: string,
			target: string,
			linkText: string,
		}),
	}),
};
QuickLinksSupportConnector.defaultProps = {
	data: null,
};

export default QuickLinksSupportConnector;
export { QuickLinksSupportConnector };
